<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container;
</script>

<style></style>

<BaseAtom _isotope="EmailSubmitAtom" {...container}>
  <div>Email Submit Placeholder</div>
</BaseAtom>